"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreightClassWithNMFC = void 0;
exports.FreightClassWithNMFC = {
    _60: '60',
    _65: '65',
    _70: '70',
    _85: '85',
    _100: '100',
    _125: '125',
    _175: '175',
    _250: '250',
    _300: '300',
    _400: '400',
    _925: '92.5'
};
//# sourceMappingURL=freight-class-with-nmfc.js.map